<template>
  <header>
    <el-drawer :visible="drawer" :direction="direction" :size="'100%'">
      <div style="max-width: 70%; margin: 0 auto;">
        <button class="button white" @click="close" style="margin-top: 20px;">閉じる</button>

        <h1 style="clear: both">フィードバック</h1>
        <p style="font-size: 13px">
          PronAid開発チームでは、「ネイティブの口」の機能に関して、
          皆様からの貴重なフィードバックを受け付けています。
          「ネイティブの口」の機能に関するご質問・ご意見・ご要望、バグの報告、新機能の提案などを
          このフォームから開発チームにお送りいただくことができます。
        </p>
        <p style="font-size: 13px">ご提供いただいた情報はバージョンアップの際、品質向上に役立てさせていただきます。</p>
        <el-form ref="form" label-width="180px">
          <el-form-item label="カテゴリー">
            <el-radio-group v-model="category">
              <el-radio class="radio-item" label="テスト・総合スコア・採点に関するもの"></el-radio>
              <el-radio class="radio-item" label="レッスンシステムに関するもの"></el-radio>
              <el-radio class="radio-item" label="レッスン動画の内容に関するもの"></el-radio>
              <el-radio class="radio-item" label="ユーザー登録・認証・課金等に関するもの"></el-radio>
              <el-radio class="radio-item" label="新機能のアイデア"></el-radio>
              <el-radio class="radio-item" label="その他"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="フィードバック内容">
            <el-input type="textarea" v-model="form"></el-input>
          </el-form-item>
          <el-form-item>
            <button class="button" style="float: right" @click.prevent="onSubmit">送信</button>
          </el-form-item>
        </el-form>
        <h1>開発チーム既知の問題点 / TODO List</h1>

        <el-collapse accordion>
          <el-collapse-item name="1">
            <template slot="title">テストに関するもの</template>
            <ol>
              <li>未完成 ☐</li>
              <li>ダウンロードしたwavファイルをシークできない（ヘッダーファイルの問題？）</li>
              <li>ダウンロードしたwavファイルの名前が文字化ける</li>
            </ol>
          </el-collapse-item>
          <el-collapse-item title="レッスンシステムに関するもの" name="2">
            <ol>
              <li>/母音+rの発音/のレッスンで、問題ボックスの上にマウスポインタを合わせても、/母音+rの発音/部分が正しくハイライトされない ☐</li>
              <li>タブに表示される録音中を意味する赤色のアイコン●が消えないときがある ☐</li>
              <li>フッターからページを切り替えても動画がリセットされない ☐</li>
              <li>outsideなどにおいてtsで発音記号表記の間違いがある ☐</li>
              <li>カテゴリ別（e.g., ～～が語頭にくる単語）のスコアゲージがリアルタイムで反映されない ☐</li>
              <li>最高スコアではなく最新スコアが登録される ☐</li>
            </ol>
          </el-collapse-item>
          <el-collapse-item title="レッスン動画の内容に関するもの" name="3">無し</el-collapse-item>
          <el-collapse-item title="ユーザー登録・認証・課金等に関するもの" name="4">無し</el-collapse-item>
          <el-collapse-item title="新機能の予定・アイデア" name="5">
            <ol>
              <li>テスト中の休憩機能。ただし時間・回数制限つき ☐</li>
            </ol>
          </el-collapse-item>
        </el-collapse>
        <h1>更新履歴</h1>
        <dl class="update">
          <dt>2019/09/07</dt>
          <dd>
            <span class="cat">Update</span>
            テスト終了後に問題のあった発音記号が分かるようになりました。
          </dd>
          <dt>2019/08/30</dt>
          <dd>
            <span class="cat">Update</span>
            「比較モードをオン」ボタンのサイズを大きくしました。
          </dd>
          <dt>2019/08/25</dt>
          <dd>
            <span class="cat">News</span>
            クローズドベータサービスを開始しました
          </dd>
          <dt>2019/08/24</dt>
          <dd>
            <span class="cat">Fixed</span>
            テスト終了時のウィンドウ動作が不安定だったのを修正しました
          </dd>
          <dt>2019/08/24</dt>
          <dd>
            <span class="cat">Fixed</span>
            レッスンページロード後1秒以内に動画を再生すると、多重で再生されるバグを修正しました
          </dd>
          <dt>2019/08/24</dt>
          <dd>
            <span class="cat">Update</span>
            パスワード再設定用ページを作成しました
          </dd>
          <dt>2019/08/22</dt>
          <dd>
            <span class="cat">Update</span>
            フィードバックページを作成しました
          </dd>
        </dl>
        <p style="font-weight:bold; text-align: right; font-size: 0.8rem">Current Version: 0.33 beta</p>
      </div>
    </el-drawer>

    <div class="navbar-left">
      <router-link to="/">
        <img class="logo" src="@/assets/logo.svg" />
      </router-link>
    </div>
    <div class="navbar-right">
      <button class="button" @click="open">フィードバック</button>
      <!-- <router-link to="/subscribe">
        <button class="button">プレミアムプランのご案内</button>
      </router-link>-->
      <!-- <router-link to="/setting">
        <button class="button white">各種設定</button>
      </router-link>-->
      <!-- <router-link to="/statistics">
        <button class="button white">統計情報</button>
      </router-link>-->
      <button class="button white" @click="signOut">サインアウト</button>
      <!-- <router-link to="/">
            <button class="button white">ダッシュボード</button>
      </router-link>-->

      <!-- <button class="button white" @click="signOut">サインアウト</button> -->

      <!-- <router-link :to="{name: 'Subscription'}">
            <button class="button">プレミアムプランのご案内</button>
      </router-link>-->
      <!-- <button class="button" @click="signOut">テストを受験（トライアル版）</button> -->
    </div>
  </header>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
import { mapGetters } from "vuex";

export default {
  mounted() {
    // console.log(this.$store.getters.user);
  },
  data() {
    return {
      drawer: false,
      direction: "ttb",
      form: "",
      category: ""
    };
  },
  destroyed() {},
  methods: {
    open() {
      this.drawer = true;
    },
    close() {
      this.drawer = false;
    },
    onSubmit() {
      let self = this;
      const addMessage = firebase.functions().httpsCallable("sendFeedback");
      addMessage({
        message: self.form,
        url: location.href,
        category: self.category,
        name: self.$store.state.auth.user.name
      })
        .then(function(result) {
          self.$notify({
            title: "成功",
            message:
              "フィードバックを送信しました。ご協力頂き有難うございました",
            type: "success"
          });
          self.drawer = false;
        })
        .catch(err => {
          this.$notify({
            title: "失敗",
            message:
              "フィードバックの送信に失敗しました。大変お手数ですがフィードバック内容を masakazu_naoi@pronaid.co.jp 宛にメールで送信して頂ければ幸いです。",
            type: "error"
          });
          // self.drawer = false;
        });
    },
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(user => {
          this.$router.replace("/");
        })
        .catch();
    },
    handleClose(done) {
      this.$confirm("Are you sure you want to close this?")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 1.3rem;
}
header {
  position: absolute;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  height: 50px;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 200;

  @include mq(sm) {
    width: 800px;
  }
  @include mq(md) {
    width: 1000px;
  }
  @include mq(lg) {
    width: 1200px;
  }
  @include mq(xl) {
    width: 1300px;
  }

  .navbar-left {
    display: flex;
    flex-direction: row;
    align-items: center;

    .logo {
      padding-top: 5px;
      height: 27px;
    }

    .trial {
      margin-left: 20px;
      padding: 2px 12px;
      font-size: 0.8rem;
      border-radius: 20px;
      border: 1px solid #ccc;
      color: #666;
    }
  }
  .navbar-right {
    justify-content: flex-end;
  }
}

.button {
  margin-left: 10px !important;
  padding: 3px 6px;
  font-weight: normal;
  font-size: 0.8rem;
}

ol {
  margin: 0;
  padding-left: 30px;
  li {
    display: list-item;
    padding: 0;
  }
}

dl.update {
  padding: 0;
  line-height: 1.8;
  width: 100%;
  font-size: 13px;
}
dl.update dt {
  width: 6em;
  float: left;
  margin: 0;
  padding: 0 0 0 5px;
}
dl.update dd {
  position: relative;
  margin: 0 0 5px;
  padding: 0 5px 5px 13em;
  border-bottom: 1px solid #ddd;
}
dl.update dd span.cat {
  display: block;
  position: absolute;
  top: 0;
  left: 7em;
  width: 4.5em;
  font-weight: normal;
  margin: 0;
  padding: 0;
  text-align: center;
  background-color: #eee;
  border-radius: 2px;
}
.radio-item {
  margin: 5px 10px;
}
</style>
